const http = require('../lib/httpClient');

const DEFAULT_FALLBACK = 'AFZone';

const tenantCodeLookup = {
  'falabella-cl': 'cl',
  'falabella-pe': 'pe',
  'falabella-ar': 'ar',
  'falabella-co': 'co',
  'marketplace-cl': 'cl',
  'marketplace-pe': 'pe',
  'marketplace-ar': 'ar',
  'marketplace-co': 'co',
  'sodimac-cl': 'cl',
  'sodimac-pe': 'pe',
  'sodimac-mx': 'mx',
  'marketplacesodimac-cl': 'cl',
  'marketplacesodimac-pe': 'pe',
  'tottus-cl': 'cl',
  'marketplacetottus-cl': 'cl',
  'tottus-pe': 'pe',
  'marketplacetottus-pe': 'pe',
};

const endpointPattern = '/s/geo/v1/zones/{tenantCode}';

async function getDefaultZone(tenantId, catalystBaseUrl = '') {
  const endpoint = endpointPattern.replace('{tenantCode}', tenantCodeLookup[tenantId]);
  const result = await http.get(`${catalystBaseUrl}${endpoint}`);

  const { responseBody } = result || {};

  if (!responseBody) return DEFAULT_FALLBACK;
  const { defaultZone } = responseBody;
  return defaultZone || DEFAULT_FALLBACK;
}

module.exports = getDefaultZone;
